export default
  'false': false
  'true': true
  'Infinity': Infinity
  'NaN': NaN
  'null': undefined
  'undefined': undefined